import { render, staticRenderFns } from "./ResultsStakeholder.vue?vue&type=template&id=36c85fdc&"
import script from "./ResultsStakeholder.vue?vue&type=script&lang=js&"
export * from "./ResultsStakeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports